import AhoyTracker from 'shared/ahoy_tracker';

export default class SocialTracker {

  constructor(pageName, ahoyTracker) {
    if (!pageName) throw 'pageName must not be null or empty';
    if (!ahoyTracker) throw 'ahoyTracker must not be null';

    this.pageName = pageName;
    this.ahoyTracker = ahoyTracker;
  }

  trackShareClick(shareTo, url) {
    if (!shareTo) throw 'shareTo must not be null or empty';
    if (!url) throw 'url must not be null or empty';

    this.ahoyTracker._sendEvent('VIDIO::SHARE', {
      share_to: shareTo,
      page: this.pageName,
      url: url
    });
  }

  static create(pageName) {
    return new SocialTracker(pageName, AhoyTracker);
  }

  static createNull() {
    return new NullSocialTracker();
  }
}

class NullSocialTracker {

  trackShareClick() {}
}